module.exports = __webpack_public_path__ + "img/organizations_card.1027e457.png";